export default "__VITE_ASSET__oMgbD_LU__"